import React, { useState, useEffect, useRef } from "react";
import { fetchWithIap, explicitTokenRefresh } from '../utils/iapService';

const App = (props) => {
 const { onLoginRequest, initialSessionId, isAuthenticating, authError } = props;
 
 const [isCallingApi, setIsCallingApi] = useState(false);
 const [apiResponse, setApiResponse] = useState(null);
 const [apiError, setApiError] = useState(null);
 
 const [activeSessionId, setActiveSessionId] = useState(initialSessionId);
 const loginTriggeredRef = useRef(false);

 useEffect(() => {
  if (initialSessionId) setActiveSessionId(initialSessionId);
 }, [initialSessionId]);

 useEffect(() => {
  const handleSessionUpdate = (e) => setActiveSessionId(e.detail);
  window.addEventListener('session-updated', handleSessionUpdate);
  return () => window.removeEventListener('session-updated', handleSessionUpdate);
 }, []);

 const handleApiCall = async () => {
  setIsCallingApi(true);
  setApiError(null);
  try {
   // fetchWithIap handles attaching ?sid= automatically and handling explicit refresh
   const response = await fetchWithIap('/api/greet', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
   });
   const data = await response.json();
   
   if (response.ok) {
    setApiResponse(data);
   } else {
    setApiError("Backend returned an error: " + JSON.stringify(data));
   }
  } catch (err) {
   setApiError("Failed to reach backend: " + err.message);
  } finally {
   setIsCallingApi(false);
  }
 };

 const handleStartFlow = () => {
  setApiResponse(null);
  setApiError(null);
  loginTriggeredRef.current = true;
  onLoginRequest(); 
 };

 useEffect(() => {
  if (activeSessionId && loginTriggeredRef.current) {
   handleApiCall();
   loginTriggeredRef.current = false; 
  }
 }, [activeSessionId]);

 // Test manual explicit refresh
 const testExplicitRefresh = async () => {
  setIsCallingApi(true);
  try {
   await explicitTokenRefresh(activeSessionId);
   setApiResponse({ message: "✅ Explicit refresh requested and successfully completed on backend!" });
  } catch (err) {
   setApiError("Refresh failed: " + err.message);
  } finally {
   setIsCallingApi(false);
  }
 };

 const isLoading = isAuthenticating || isCallingApi;

 return (
 <div style={{ padding: "30px", fontFamily: "sans-serif", textAlign: "center" }}>
  <h2>Login & Explicit Auto-Refresh</h2>
  
  <button onClick={handleStartFlow} disabled={isLoading} style={btnStyle(isLoading)}>
  {isAuthenticating ? "Authenticating..." : isCallingApi ? "Working..." : "Sign In & Get Greeting"}
  </button>

   {activeSessionId && (
   <div>
    <button onClick={handleApiCall} disabled={isLoading} style={{...btnStyle(isLoading), backgroundColor: "#107c41"}}>
     {isCallingApi ? "Calling API..." : "Call Greet API Only"}
    </button>

    <button onClick={testExplicitRefresh} disabled={isLoading} style={{...btnStyle(isLoading), backgroundColor: "#28a745", marginLeft: "10px"}}>
     Force Explicit Refresh
    </button>
   </div>
  )}

  {authError && <p style={{ color: "red", fontWeight: "bold" }}>{authError}</p>}
  {apiError && <p style={{ color: "red", fontWeight: "bold" }}>{apiError}</p>}

  {apiResponse && (
  <div style={{ marginTop: "20px", textAlign: "left" }}>
   <pre style={{ backgroundColor: "#f4f4f4", padding: "10px", borderRadius: "4px", fontSize: "12px", whiteSpace: "pre-wrap" }}>
   {JSON.stringify(apiResponse, null, 2)}
   </pre>
  </div>
  )}

  {activeSessionId && (
   <div style={{ marginTop: "20px", textAlign: "left" }}>
   <p style={{ marginTop: "20px" }}><strong>Active Session ID (JWT hidden on server):</strong></p>
   <code style={{display: 'block', padding: '10px', backgroundColor: '#e2e8f0', borderRadius: '4px'}}>
    {activeSessionId}
   </code>
   </div>
  )}
 </div>
 );
};

const btnStyle = (disabled) => ({
 backgroundColor: disabled ? "#cccccc" : "#0078d4",
 color: "white", border: "none", padding: "12px 24px",
 fontSize: "16px", borderRadius: "4px",
 cursor: disabled ? "not-allowed" : "pointer",
 marginBottom: "20px"
});

export default App;







// import React, { useState, useEffect, useRef } from "react";
// import { fetchWithIap, silentTokenRefresh } from '../utils/iapService';

// const App = (props) => {
//  const { onLoginRequest, initialIapToken, isAuthenticating, authError } = props;
 
//  const [isCallingApi, setIsCallingApi] = useState(false);
//  const [apiResponse, setApiResponse] = useState(null);
//  const [apiError, setApiError] = useState(null);
 
//  // Track the active token locally so it updates when a silent refresh occurs
//  const [activeToken, setActiveToken] = useState(initialIapToken);
//  const loginTriggeredRef = useRef(false);

//  // Update local token if parent passes a new one
//  useEffect(() => {
//   if (initialIapToken) setActiveToken(initialIapToken);
//  }, [initialIapToken]);

//  // Listen for silent refresh updates triggered by iapService.js
//  useEffect(() => {
//   const handleTokenUpdate = (e) => setActiveToken(e.detail);
//   window.addEventListener('token-updated', handleTokenUpdate);
//   return () => window.removeEventListener('token-updated', handleTokenUpdate);
//  }, []);

//  const handleApiCall = async () => {
//   setIsCallingApi(true);
//   setApiError(null);
//   try {
//    // Because we use fetchWithIap, if it happens to be expired, 
//    // it will automatically refresh it behind the scenes before returning the response!
//    const response = await fetchWithIap('/api/greet', {
//     method: 'GET',
//     headers: { 'Content-Type': 'application/json' }
//    });
//    const data = await response.json();
   
//    if (response.ok) {
//     setApiResponse(data);
//    } else {
//     setApiError("Backend returned an error: " + JSON.stringify(data));
//    }
//   } catch (err) {
//    setApiError("Failed to reach backend: " + err.message);
//   } finally {
//    setIsCallingApi(false);
//   }
//  };

//  const handleStartFlow = () => {
//   setApiResponse(null);
//   setApiError(null);
//   loginTriggeredRef.current = true;
//   onLoginRequest(); 
//  };

//  // Trigger API automatically on first manual login
//  useEffect(() => {
//   if (activeToken && loginTriggeredRef.current) {
//    handleApiCall();
//    loginTriggeredRef.current = false; 
//   }
//  }, [activeToken]);

//  // ========================================================
//  // TEST BUTTON: Force a silent refresh to test the flow
//  // ========================================================
//  const testSilentRefresh = async () => {
//   setIsCallingApi(true);
//   try {
//    const oldToken = activeToken;
//    const newToken = await silentTokenRefresh(oldToken);
   
//    setApiResponse({ 
//     message: "✅ Silent refresh successful!", 
//     oldTokenStarts: oldToken.slice(0, 30) + "...",
//     newTokenStarts: newToken.slice(0, 30) + "..."
//    });
//   } catch (err) {
//    setApiError("Refresh failed: " + err.message);
//   } finally {
//    setIsCallingApi(false);
//   }
//  };

//  const isLoading = isAuthenticating || isCallingApi;

//  return (
//   <div style={{ padding: "30px", fontFamily: "sans-serif", textAlign: "center" }}>
//    <h2>Login & Auto-Refresh</h2>
   
//    <button onClick={handleStartFlow} disabled={isLoading} style={btnStyle(isLoading)}>
//     {isAuthenticating ? "Authenticating..." : isCallingApi ? "Working..." : "Sign In & Get Greeting"}
//    </button>

//    {/* TEST BUTTON - ONLY SHOWS AFTER USER IS LOGGED IN */}
//    {activeToken && (
//     <button onClick={testSilentRefresh} disabled={isLoading} style={{...btnStyle(isLoading), backgroundColor: "#28a745", marginLeft: "10px"}}>
//      Test Silent Refresh
//     </button>
//    )}

//    {authError && <p style={{ color: "red", fontWeight: "bold" }}>{authError}</p>}
//    {apiError && <p style={{ color: "red", fontWeight: "bold" }}>{apiError}</p>}

//    {apiResponse && (
//     <div style={{ marginTop: "20px", textAlign: "left" }}>
//      <pre style={{ backgroundColor: "#f4f4f4", padding: "10px", borderRadius: "4px", fontSize: "12px", whiteSpace: "pre-wrap" }}>
//       {JSON.stringify(apiResponse, null, 2)}
//      </pre>
//     </div>
//    )}

//    {activeToken && (
//      <div style={{ marginTop: "20px", textAlign: "left" }}>
//       <p style={{ marginTop: "20px" }}><strong>Active JWT Token:</strong></p>
//       <textarea 
//        readOnly 
//        value={activeToken} 
//        style={{ width: "100%", height: "80px", fontSize: "11px", padding: "8px" }}
//       />
//      </div>
//    )}
//   </div>
//  );
// };

// const btnStyle = (disabled) => ({
//  backgroundColor: disabled ? "#cccccc" : "#0078d4",
//  color: "white", border: "none", padding: "12px 24px",
//  fontSize: "16px", borderRadius: "4px",
//  cursor: disabled ? "not-allowed" : "pointer",
//  marginBottom: "20px"
// });

// export default App;
